import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';

const alertVariants = cva(
  "group/alert relative grid w-full gap-0.5 rounded-lg border px-4 py-3 text-left text-sm has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:pr-18 has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-2.5 *:[svg]:row-span-2 *:[svg]:translate-y-0.5 *:[svg]:text-current *:[svg:not([class*='size-'])]:size-5",
  {
    variants: {
      variant: {
        default: 'bg-surface-muted-default',
        destructive: 'bg-surface-danger-subtle-default *:[svg]:text-current',
        warning:
          'sborder-warning-default bg-surface-warning-subtle-default *:[svg]:stext-warning-default',
        success:
          'bg-surface-success-subtle-default *:[svg]:text-icon-success-default',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn('revers-alert', alertVariants({ variant }), className)}
      {...props}
    />
  );
}

export function AlertTitle({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-title"
      className={cn(
        'revers-alert-title',
        'font-medium stext-base-default group-has-[>svg]/alert:col-start-2 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:stext-base-default',
        className,
      )}
      {...props}
    />
  );
}

export function AlertDescription({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        'revers-alert-description',
        'text-sm text-balance stext-muted-default md:text-pretty [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:stext-base-default [&_p:not(:last-child)]:mb-4',
        className,
      )}
      {...props}
    />
  );
}

export function AlertAction({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-action"
      className={cn(
        'revers-alert-action',
        'absolute top-2.5 right-3',
        className,
      )}
      {...props}
    />
  );
}
